import { useCallback, useState } from 'react';
import { loadChargeTogglesFromStorage, saveChargeTogglesToStorage } from './billingDashboardUtils';

export type BillingSettings = {
  bill_travel_time: boolean;
  bill_travel_km: boolean;
  bill_onsite_labour: boolean;
};

function getInitialBillingSettings(): BillingSettings {
  const stored = loadChargeTogglesFromStorage();
  if (stored) {
    return {
      bill_travel_time: stored.travel_time,
      bill_travel_km: stored.travel_km,
      bill_onsite_labour: stored.onsite_labour,
    };
  }
  return {
    bill_travel_time: true,
    bill_travel_km: true,
    bill_onsite_labour: true,
  };
}

export function useChargeToggles() {
  const [billingSettings, setBillingSettings] = useState<BillingSettings>(getInitialBillingSettings);

  const handleChargeToggle = useCallback((key: 'bill_travel_time' | 'bill_travel_km' | 'bill_onsite_labour', value: boolean) => {
    setBillingSettings((prev) => {
      const next = { ...prev, [key]: value };
      saveChargeTogglesToStorage({
        travel_km: next.bill_travel_km,
        travel_time: next.bill_travel_time,
        onsite_labour: next.bill_onsite_labour,
      });
      return next;
    });
  }, []);

  return {
    billingSettings,
    setBillingSettings,
    handleChargeToggle,
  };
}
